import { useEffect, useState } from 'react'
import { applyUpdate, onAppUpdate } from '../utils/appUpdate'
import styles from './UpdateToast.module.css'

/**
 * Appears when a new version has already been installed in the background.
 * Outside the player the page reloads on its own; here (mid-playback) we wait
 * for the tap so an update never interrupts a video.
 */
export function UpdateToast() {
  const [visible, setVisible] = useState(false)

  useEffect(
    () =>
      onAppUpdate((event) => {
        if (event === 'update-ready') setVisible(true)
      }),
    []
  )

  if (!visible) return null

  return (
    <div className={styles.toast} role="status" aria-live="polite">
      <span className={styles.icon}>🚀</span>
      <div className={styles.body}>
        <strong className={styles.title}>নতুন আপডেট প্রস্তুত</strong>
        <span className={styles.text}>
          ভিডিও শেষ হলে আপডেট করে নিন — নতুন ভার্সন অটো লোড হবে।
        </span>
      </div>
      <div className={styles.actions}>
        <button className={styles.updateBtn} onClick={applyUpdate}>
          এখনই আপডেট
        </button>
        <button
          className={styles.laterBtn}
          onClick={() => setVisible(false)}
          aria-label="Dismiss update notice"
        >
          পরে
        </button>
      </div>
    </div>
  )
}
